import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AppUpdate } from './components/AppUpdate.js';
import { appUpdate, startAppUpdateFallback } from './lib/app-update.js';
import { registerSW } from './lib/sw-register.js';
import { startSyncEngine } from './lib/sync.js';
import { bootTheme } from './lib/theme.js';
import { installKeyboardAware } from './lib/keyboard-aware.js';
import { initSentry } from './lib/sentry.js';
import { queryClient } from './lib/queryClient.js';
import './lib/i18n.js'; // init i18next до первого рендера
import './index.css';

// Sentry — раньше всего, чтобы покрыть ошибки startup
initSentry();

// Тему применяем ДО render — иначе будет «вспышка» дефолтной палитры
bootTheme();

// Глобально: visualViewport → --jb-kb-h + локальная прокрутка input/textarea
installKeyboardAware();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <AppUpdate />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

// Service Worker — регистрируем после mount-а, чтобы UI откликнулся быстрее
registerSW((apply) => appUpdate.offer(apply));
startAppUpdateFallback();

// Sync engine — фоновая отправка outbox-мутаций при возврате онлайна
startSyncEngine();
